export const createAnswer = (payload?: any) => ({
    type: "@saga/CREATE_ANSWER",
    payload
});

